<div class="flex flex-wrap mt-8 mb-6">

    @let user = (user$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (user?.uid === studentId || user?.uid === student?.parentId)
            {
            <app-btn-action label="Submit Work" (clicked)="onSubmitAssignment()" bgColor="bg-primary-500"
                textColor="text-white" icon="fa fa-add"></app-btn-action>
            }
        </div>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ assignment?.lessonName }}
        </h1>
    </div>

    @if (user?.uid === studentId || user?.uid === student?.parentId) {
    @let submittedAssignments = (studentwork | async);
    <label class="block uppercase text-blueGray-600 text-xs font-bold mt-4 mb-2">
        Student Work
    </label>
    @for (item of submittedAssignments; track $index) {
    <div class="bg-white shadow-lg rounded w-full px-4 py-3 mb-4">
        <div class="cursor-default flex flex-col gap-1">
            <div class="flex flex-row items-start justify-between w-full mb-1">
                <a [href]="item.url || null" class="flex flex-col justify-start"
                    [attr.target]="item.url ? '_blank' : null" [attr.rel]="item.url ? 'noopener noreferrer' : null">
                    <div class="flex flex-row justify-start">
                        <div [class]="item.url ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                            <i class="far fa-file-pdf text-lg"></i>
                        </div>
                        <div class="flex flex-col justify-start ml-4">
                            <span class="text-primary-300 text-xs whitespace-nowrap">
                                {{ item.created | moment: 'Do MMM YYYY' }}
                            </span><span class="text-primary-500 text-sm font-semibold whitespace-nowrap">
                                {{ item.fileName || 'No File Name' }}
                            </span>
                        </div>
                    </div>
                </a>
                <div class="flex flex-row gap-2 whitespace-nowrap">
                    <app-btn-fab (click)="onDelete(item.id)" icon="fa fa-trash-can"
                        textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                </div>
            </div>
        </div>
    </div>
    }
    }
    <label class="block uppercase text-blueGray-600 text-xs font-bold mt-4 mb-2">
        Assignment
    </label>
    @if(assignment?.assignmentUrl) {
    <div class="rounded-t block w-full overflow-x-auto shadow-lg rounded bg-white">
        <rich-text-editor [jsonFormat]="htmlData" class="w-full" [isEditable]="false"></rich-text-editor>
    </div>
    } @else {
    <div class="w-full text-center">
        <span class="text-primary font-bold text-sm">No Content Available</span>
    </div>
    }
</div>